import { render, staticRenderFns } from "./MaterialUnpackingPackage.vue?vue&type=template&id=4dc13340&scoped=true"
import script from "./MaterialUnpackingPackage.vue?vue&type=script&lang=js"
export * from "./MaterialUnpackingPackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc13340",
  null
  
)

export default component.exports